'use client'

import { useHeaderState } from 'header-utils/context/HeaderContext/useHeaderState'
import { useMenus } from 'menu/hooks/useMenus'
import dynamic from 'next/dynamic'
import { Responsive } from 'responsive/components/Responsive/Responsive'
import { ID_STRUCTURE_CONTENT } from '../../constants/idStructureContent'
import { useMenuData } from '../../hooks/useMenuData'
import { MenuLabelsProvider, useMenuLabelsContext } from '../MenuLabelsProvider'
import { OpenMenu } from '../OpenMenu/OpenMenu'
import styles from './WrapperMenu.module.css'

const DynamicStructureLPlus = dynamic(() =>
	import('../Structure/StructureLPlus').then((mod) => mod.StructureLPlus)
)

const DynamicStructureSM = dynamic(() =>
	import('../Structure/StructureSM').then((mod) => mod.StructureSM)
)

const DynamicBackdrop = dynamic(() =>
	import('../Backdrop/Backdrop').then((mod) => mod.Backdrop)
)

export function WrapperMenu() {
	const { firstOpen, hasDataLoaded } = useMenus()
	const { isSearchOpen } = useHeaderState()

	useMenuData(firstOpen)

	if (isSearchOpen) {
		return null
	}

	return (
		<div
			className={styles.menu}
			data-testid='inspirational.menu'
			id='wrapperMenu'
		>
			<OpenMenu />
			<MenuLabelsProvider firstOpen={firstOpen}>
				<WrapperMenuContent
					firstOpen={firstOpen}
					hasDataLoaded={hasDataLoaded}
				/>
			</MenuLabelsProvider>
		</div>
	)
}

export function WrapperMenuContent({
	hasDataLoaded,
	firstOpen,
}: {
	readonly hasDataLoaded: boolean
	readonly firstOpen: boolean
}) {
	const { isLoading } = useMenuLabelsContext()

	return hasDataLoaded && firstOpen && !isLoading ? (
		<>
			<DynamicBackdrop />
			<Responsive onLargeOrGreater>
				<DynamicStructureLPlus />
			</Responsive>
			<Responsive onLessThanLarge>
				<DynamicStructureSM />
			</Responsive>
		</>
	) : (
		<div id={ID_STRUCTURE_CONTENT} />
	)
}
